import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AlertController} from '@ionic/angular';
import {ConfirmationButtonOptionModel} from './model/confirmationButtonOption.model';
import {DialogController} from '../../../../modules/common/dialog/dialogController';
import {
    ConfirmationButtonDialogComponent,
    ConfirmationButtonDialogInput, ConfirmationButtonDialogResult
} from './confirmation-button-dialog/confirmation-button-dialog.component';

@Component({
    selector: 'app-confirmation-button',
    template: `
        <app-button (clickEvent)="presentAlertConfirm()"
                    [color]="color"
                    [tooltip]="tooltip"
                    [fill]="fill"
                    [iconName]="iconName"
                    [label]="label"
                    [slot]="slot"
                    [size]="size"
                    [withPadding]="withPadding"
                    [loading]="loading"
                    [disabled]="disabled">
        </app-button>
    `
})
export class ConfirmationButtonComponent {

    @Input() slot = '';
    @Input() iconName;
    @Input() size: string;
    @Input() withPadding = true;
    @Input() withMargin = true;
    @Input() fill = 'clear';
    @Input() label;
    @Input() color: 'primary' | 'accent' | 'warn' = 'accent';
    @Input() options: ConfirmationButtonOptionModel = new ConfirmationButtonOptionModel();
    @Input() disabled = false;
    @Input() loading: boolean;
    @Input() tooltip: string;

    @Output() confirm = new EventEmitter<string>();

    constructor(private alertController: AlertController,
                private dialogController: DialogController) {
    }

    presentAlertConfirm() {
        if (this.options) {
            const input: ConfirmationButtonDialogInput = {
                options: this.options
            };
            this.dialogController.open(ConfirmationButtonDialogComponent,
                input,
                {
                    title: 'Confirmation requise',
                    width: '500px',
                    height: '200px'
                }).afterClosed()
                .toPromise()
                .then((result: ConfirmationButtonDialogResult) => {
                    if (result && result.value) {
                        this.confirm.emit(result.value);
                    }
                });
        } else {
            this.confirm.emit(undefined);
        }
    }
}
